<div class="d-welcome">
	<h2>
		Welcome{{ panelStatus?.firstName !== null ? ', ' + panelStatus?.firstName : '' }}
		{{ panelStatus?.lastName !== null ? panelStatus?.lastName : '' }}
	</h2>
	<ng-container *ngxPermissionsExcept="[USER_LEVEL.HUBBELL_NOT_ELIGIBLE]">
		<div class="d-w-action">
			<ul [ngClass]="isMatchedMember ? '' : 'disabled-button'">
				<li
					[routerLink]="['/messaging/mailbox/inbox']"
					appEheAnalytics
					[data]="{
						pageUrl: '/dashboard',
						redirectedTo: '/scheduling/create/appointment',
						componentName: 'welcome-panel',
						id: 'Dashboard welcome panel Inbox',
						placement: 'Dashboard welcome panel'
					}">
					<a>
						<i class="far fa-envelope"></i>
						<span class="d-badge" *ngIf="messagingService.getCurrentMessageCount().getValue().inbox > 0">{{
							messagingService.getCurrentMessageCount().getValue().inbox
						}}</span>
					</a>
				</li>
				<li
					[routerLink]="['/messaging/mailbox/inbox']"
					appEheAnalytics
					[data]="{
						pageUrl: '/dashboard',
						redirectedTo: '/scheduling/create/appointment',
						componentName: 'welcome-panel',
						id: 'Dashboard welcome panel messages',
						placement: 'Dashboard welcome panel'
					}">
					<a *ngIf="messagingService.getCurrentMessageCount().getValue().inbox > 0">
						<span>{{ messagingService.getCurrentMessageCount().getValue().inbox }} new messages</span>
					</a>
					<a *ngIf="messagingService.getCurrentMessageCount().getValue().inbox === 0 || !isMatchedMember">
						No new messages
					</a>
				</li>
			</ul>
		</div>
	</ng-container>
	<!-- <a href="#" [routerLink]="['/scheduling/create/appointment']"></a> -->
	<div class="d-carousel" *ngIf="panelStatus?.welcomePanel !== undefined">
		<ng-container [ngSwitch]="panelStatus?.welcomePanel">
			<div *ngSwitchCase="'NON_MATCHED'">
				<div class="d-carousel-content">
					<h6 [translate]="'dashboard.welcome-panel.account-verification.title'">
						Account verification takes up to 24 hours.
					</h6>
					<p [translate]="'dashboard.welcome-panel.health-assessment-unavailable'">
						Some myEHE features, including your Health Assessment, are unavailable during this period.
					</p>
					<p [translate]="'dashboard.welcome-panel.contact-if-difficulty'">
						If you are still experiencing difficulty after 24 hours, please contact Member Services at 800.362.8671 or
						<a class="link pb-0" href="mailto:MemberServices@ehe.health">MemberServices&#64;ehe.health.</a>
					</p>
					<p [translate]="'dashboard.welcome-panel.hard-copy-health-assessment'">
						If your exam appointment comes before you have full myEHE access, a hard copy Health Assessment is available
						to bring with you.
						<a
							class="link pb-0 d-inline"
							href="https://ehe.health/wp-content/uploads/2020/12/healthassessmentform.pdf"
							target="_blank">
							<u>Download PDF.</u>
						</a>
					</p>
					<p class="font-italic" [translate]="'dashboard.welcome-panel.reference-number'">Reference Number: 3</p>
				</div>
			</div>
			<div *ngSwitchCase="'NO_SCHEDULED_PE'">
				<div class="d-carousel-wrapper">
					<a
						href=""
						[routerLink]="['/scheduling/create/appointment']"
						appEheAnalytics
						[data]="{
							pageUrl: '/dashboard',
							redirectedTo: '/scheduling/create/appointment',
							componentName: 'welcome-panel',
							id: 'welcome panel-schedule your physical exam',
							placement: 'Dashboard welcome panel'
						}">
						<div class="d-carousel-content">
							<h6 [translate]="'dashboard.welcome-panel.schedule-your-exam.title'">Schedule your physical exam.</h6>
							<p [translate]="'dashboard.welcome-panel.schedule-your-exam.link'">
								Please click here to schedule your physical exam.
							</p>
						</div>
					</a>
				</div>
			</div>
			<div *ngSwitchCase="'UPCOMING_PE'">
				<div class="d-carousel-wrapper">
					<a
						href=""
						[routerLink]="['/scheduling/appointments']"
						appEheAnalytics
						[data]="{
							pageUrl: '/dashboard',
							redirectedTo: '/scheduling/appointments',
							componentName: 'welcome-panel',
							id: 'welcome panel-Appointments',
							placement: 'Dashboard welcome panel'
						}">
						<div class="d-carousel-content">
							<h6 [translate]="'dashboard.welcome-panel.appointment-panel.title'">Your exam is scheduled!</h6>
							<p>
								<span *ngIf="panelStatus?.daysLeftForNextPE > 1">
									<span [translate]="'dashboard.welcome-panel.appointment-panel.description.exam-scheduled-after'">
										Your physical exam is in
									</span>
									{{ panelStatus?.daysLeftForNextPE }}
									<span
										[translate]="'dashboard.welcome-panel.appointment-panel.description.exam-scheduled-after-suffix'">
										days.
									</span>
								</span>
								<span *ngIf="panelStatus?.daysLeftForNextPE <= 1">
									<span [translate]="'dashboard.welcome-panel.appointment-panel.description.exam-scheduled'">
										Your physical exam is scheduled for
									</span>
									<span
										*ngIf="panelStatus?.daysLeftForNextPE === 0"
										[translate]="'dashboard.welcome-panel.appointment-panel.description.exam-scheduled-today'">
										today.
									</span>
									<span
										*ngIf="panelStatus?.daysLeftForNextPE === 1"
										[translate]="'dashboard.welcome-panel.appointment-panel.description.exam-scheduled-tomorrow'">
										tomorrow.
									</span>
								</span>
								<span [translate]="'dashboard.welcome-panel.appointment-panel.description.review'">
									Please review your appointment details here.
								</span>
							</p>
						</div>
					</a>
				</div>
			</div>
			<ng-template
				[ngxPermissionsExcept]="[USER_LEVEL.CATALENT_CLIENT]"
				[ngxPermissionsOnly]="[MODULE_LEVEL.HM, MODULE_LEVEL.PW]">
				<div *ngSwitchCase="'PENDING_REPORTS'">
					<div class="d-carousel-wrapper" *ngxPermissionsExcept="[USER_LEVEL.CATALENT_CLIENT]">
						<a
							href=""
							[routerLink]="['/health/mentor']"
							appEheAnalytics
							[data]="{
								pageUrl: '/dashboard',
								redirectedTo: '/health/mentor',
								componentName: 'welcome-panel',
								id: 'welcome panel-Connect with Health Coach',
								placement: 'Dashboard welcome panel'
							}">
							<div class="d-carousel-content">
								<h6 [translate]="'dashboard.welcome-panel.completed-your-exam.title'">
									Your exam is completed. You can now connect with a Health Coach or continue your coaching.
								</h6>
							</div>
						</a>
					</div>
				</div>
			</ng-template>
			<div *ngSwitchCase="'REPORTS_IN'">
				<div class="d-carousel-wrapper">
					<a
						href=""
						[routerLink]="['/results']"
						appEheAnalytics
						[data]="{
							pageUrl: '/dashboard',
							redirectedTo: '/results',
							componentName: 'welcome-panel',
							id: 'welcome panel-Health Portfolio results',
							placement: 'Dashboard welcome panel'
						}">
						<div class="d-carousel-content">
							<h6 [translate]="'dashboard.welcome-panel.exam-results.title'">Your exam results are in.</h6>
							<p [translate]="'dashboard.welcome-panel.review-results.title'">
								Head over to Health Portfolio to review your results.
							</p>
						</div>
					</a>
				</div>
			</div>
			<div *ngSwitchCase="'BIOMETRIC_REPORTS_IN'">
				<div class="d-carousel-wrapper">
					<a
						href=""
						[routerLink]="['/results']"
						[queryParams]="{ fromBiometrics: 'true' }"
						appEheAnalytics
						[data]="{
							pageUrl: '/dashboard',
							redirectedTo: '/results',
							componentName: 'welcome-panel',
							id: 'welcome panel-Health Portfolio results',
							placement: 'Dashboard welcome panel'
						}">
						<div class="d-carousel-content">
							<h6 [translate]="'dashboard.welcome-panel.biometric-results.title'">
								Your Biometric Screening results are in
							</h6>
							<p [translate]="'dashboard.welcome-panel.review-biometric-results.title'">
								Please click here to review your Biometric Screening results.
							</p>
						</div>
					</a>
				</div>
			</div>
			<div *ngSwitchCase="'PENDING_BIOMETRIC_REPORTS'">
				<div class="d-carousel-wrapper-pending">
					<div class="d-carousel-content">
						<p [translate]="'dashboard.welcome-panel.biometric-results.title-pending'">
							Your Biometric Screening Results Are Pending
						</p>
					</div>
				</div>
			</div>
		</ng-container>
		<div class="d-carousel-pagination" *ngIf="state === 2 && upcomingAppts.length > 1">
			<ul>
				<li *ngFor="let appt of upcomingAppts; let i = index">
					<a [class.active]="slideIndex === i" (click)="currentSlide(i)"></a>
				</li>
			</ul>
		</div>
	</div>
</div>
